import { html } from "haunted";

export const ExpandIcon = () => {
  return html`
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="384"
      height="448"
      viewBox="0 0 384 448"
    >
      <title></title>
      <g id="icomoon-ignore"></g>
      <path
        fill="#fff"
        d="M188.75 264c0 2-1 4.25-2.5 5.75l-83 83 36 36c3 3 4.75 7 4.75 11.25 0 8.75-7.25 16-16 16h-112c-8.75 0-16-7.25-16-16v-112c0-8.75 7.25-16 16-16 4.25 0 8.25 1.75 11.25 4.75l36 36 83-83c1.5-1.5 3.75-2.5 5.75-2.5s4.25 1 5.75 2.5l28.5 28.5c1.5 1.5 2.5 3.75 2.5 5.75zM384 48v112c0 8.75-7.25 16-16 16-4.25 0-8.25-1.75-11.25-4.75l-36-36-83 83c-1.5 1.5-3.75 2.5-5.75 2.5s-4.25-1-5.75-2.5l-28.5-28.5c-1.5-1.5-2.5-3.75-2.5-5.75s1-4.25 2.5-5.75l83-83-36-36c-3-3-4.75-7-4.75-11.25 0-8.75 7.25-16 16-16h112c8.75 0 16 7.25 16 16z"
      ></path>
    </svg>
  `;
};
